import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button } from "@material-ui/core";

import { updateUser } from "actions/user";
import DynamicDialog from "../Dialogs/Dialog.jsx";
import { getDefaultState } from "reducers/user.js";

export default function SaveLoadButtons({
	saveText = "Download Project",
	loadText = "Load Project",
	clearText = null,
	...props
}) {
	const user = useSelector((state) => state.user);
	const dispatch = useDispatch();

	var fileInput;

	const [clearDialogOpen, setClearDialogOpen] = React.useState(false);

	const download = () => {
		// modifying download project functionality-issue with download parameters when downloaded from user input and reports page
		var now = new Date();
		var filename =
			(user.agopname ?? "") + "_" + now.toLocaleDateString("en-CA") + "_" + now.toLocaleTimeString("en-GB") + ".txt"; //Canada format for the date, UK format for the time

		var element = document.createElement("a");
		console.log("whats user here", user);
		const cleanedUser = JSON.parse(JSON.stringify(user));
		if (Array.isArray(cleanedUser.fields)) {
			cleanedUser.fields.forEach((field) => {
				delete field.results;
				delete field.senateDistricts;
				delete field.assemblyDistricts;
				delete field.apns;
				delete field.censusTracts;
				delete field.isEconomicallyDisadvantaged;
			});
		}
		delete cleanedUser.pumpResults;
		element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(JSON.stringify(cleanedUser)));

		element.setAttribute("download", filename);

		element.style.display = "none";
		document.body.appendChild(element);

		element.click();

		document.body.removeChild(element);
	};

	const upload = () => {
		fileInput = document.createElement("input");
		fileInput.type = "file";
		fileInput.style.display = "none";
		fileInput.onchange = readFile;
		fileInput.func = loadUser;
		document.body.appendChild(fileInput);
		fileInput.click();
	};

	const readFile = (event) => {
		var file = event.target.files[0];

		if (!file) {
			// should we remove the fileInput element here?
			return;
		}

		var reader = new FileReader();

		reader.onload = function (e) {
			var contents = e.target.result;
			fileInput.func(contents);
			document.body.removeChild(fileInput);
		};

		reader.readAsText(file);
	};

	const loadUser = (contents) => {
		var user = JSON.parse(contents);

		if (user) {
			// allow backward compatibility with old project files
			if (user.electricity && user.electricity.annualkwh !== "" && user.electricity.annualkwh != null && !user.electricity.monthlyKWh) {
				user.electricity.monthlyKWh = Array(12).fill(user.electricity.annualkwh / 12);
			}

			dispatch(updateUser(user));
		}
	};

	const handleClearData = () => {
		// Reset user state to default
		dispatch(updateUser(getDefaultState()));

		// Reset map view to states layer (aka California)
		if (window.map) {
			const statesLayer = window.map
				.getLayers()
				.getArray()
				.find((layer) => layer.get("title") == "States");
			window.map.getView().fit(statesLayer.getSource().getExtent());
		}
		setClearDialogOpen(false);
	};

	return (
		<Box
			style={{ display: "flex", gap: 16 }}
			flexDirection="row"
			justifyContent="space-around"
			alignItems="center"
			flexWrap="wrap"
		>
			{saveText && (
				<Button
					variant="contained"
					color="primary"
					title="Download project to resume at a later time"
					onClick={download}
				>
					{saveText}
				</Button>
			)}
			{loadText && (
				<Button variant="contained" color="primary" title="Upload project file to resume data entry" onClick={upload}>
					{loadText}
				</Button>
			)}
			{clearText && (
				<Button
					variant="contained"
					// color="secondary"
					title="Clear all data and start over"
					onClick={() => setClearDialogOpen(true)}
				>
					Clear Data
				</Button>
			)}
			<DynamicDialog
				open={clearDialogOpen}
				labelId="clearDataDialog"
				title="Clear All Data?"
				buttons={[
					<Button key="cancel" onClick={() => setClearDialogOpen(false)} variant="contained">
						Cancel
					</Button>,
					// todo: make this button more clearly a red/warning color
					<Button key="confirm" onClick={handleClearData} color="secondary" variant="contained">
						Clear Data
					</Button>,
				]}
			>
				<p>Are you sure you want to clear all data and start over? This cannot be undone.</p>
			</DynamicDialog>
		</Box>
	);
}
